module.exports = __webpack_public_path__ + "static/sales1-c6a1a200a037e4fbae6dbeec2444c2dc.png";